import { useEffect, useRef, useState } from "react";
import { station } from "./api";

/**
 * Polls station state at a steady interval and exposes {state, error}.
 * Interval defaults to 300ms which comfortably matches the tactical UI
 * without saturating the network in field conditions.
 */
export function useStationState(interval = 300) {
  const [state, setState] = useState(null);
  const [error, setError] = useState(null);
  const active = useRef(true);

  useEffect(() => {
    active.current = true;
    let timer = null;
    const tick = async () => {
      try {
        const s = await station.state();
        if (active.current) {
          setState(s);
          setError(null);
        }
      } catch (e) {
        if (active.current) setError(e.message || "connection lost");
      } finally {
        if (active.current) timer = setTimeout(tick, interval);
      }
    };
    tick();
    return () => {
      active.current = false;
      if (timer) clearTimeout(timer);
    };
  }, [interval]);

  return { state, error };
}
